import { render, staticRenderFns } from "./FormP9.vue?vue&type=template&id=0ffb972a&scoped=true"
import script from "./FormP9.vue?vue&type=script&lang=ts"
export * from "./FormP9.vue?vue&type=script&lang=ts"
import style0 from "./FormP9.vue?vue&type=style&index=0&id=0ffb972a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffb972a",
  null
  
)

export default component.exports